import { JsonInput } from '@mantine/core';
import React, { FC } from 'react';

import { FieldRendererProps } from '@portals/types';

const JsonField: FC<FieldRendererProps> = ({
  field,
  value,
  handleBlur,
  setFieldValue,
  required,
  readOnly,
  disabled,
  error,
}) => {
  const { name, title, placeholder, inputProps } = field;
  const { startAdornment, endAdornment, ...restInputProps } = inputProps || {};

  return (
    <JsonInput
      validationError="Invalid json"
      data-testid={'json-input-' + name}
      icon={startAdornment}
      rightSection={endAdornment}
      label={title}
      name={name}
      error={error}
      required={required}
      placeholder={placeholder || ''}
      value={value}
      disabled={disabled || readOnly}
      onChange={(value) => setFieldValue(field.name, value)}
      onBlur={handleBlur}
      minRows={15}
      size="lg"
      {...restInputProps}
    />
  );
};

export default JsonField;
